import {gql} from '@apollo/client';

export const SEE_POPUP = gql`
	mutation SeePopup($id: Int!) {
		seePopup(id: $id)
	}
`;
